import { Drawer } from 'vaul'
import { Icon } from 'blaze-ui/icons/Types'
import { Button } from 'blaze-ui/Button'
import { ButtonVariant } from 'blaze-ui/Button/Types'
import Styles from './Drawer.module.scss'
import cx from 'classnames'

export interface CloseProps {
  label?: string
  icon?: Icon
  variant?: ButtonVariant
  position?: 'left' | 'right'
}

export const Close = ({ label = 'Cancel', icon, variant = 'ghost', position = 'left' }: CloseProps) => (
  <div className={cx(Styles.closeButton, Styles[position])}>
    <Drawer.Close asChild>
      <Button data-testid="drawer-close-btn" frontIcon={icon} variant={variant} rounded>
        {label}
      </Button>
    </Drawer.Close>
  </div>
)
